module.exports = __webpack_public_path__ + "assets/52223a0d7f839eb95128ed7c5fa6589b.png";